import { render, staticRenderFns } from "./LiabilityCreditCardEstatePlanning.vue?vue&type=template&id=3959fa78"
import script from "./LiabilityCreditCardEstatePlanning.vue?vue&type=script&lang=js"
export * from "./LiabilityCreditCardEstatePlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports